import React from "react";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Modal, Container, Button, Row, Card, Col, Spinner } from "react-bootstrap";
import { seleccionarPsa, seleccionTuID } from "./ProveedorFirmaService";
import default_psa from '../../images/default_psa.png';
import xCircle from '../../styles/icons/x-circle.svg'
import { TUID } from '../../constans/constants'
import { loadSignature, createGostCanvasAndGetAppareance } from "../tiposDocumento/AparienciaServicios";
import { getUsuarioLogueado } from "../login/SesionService";
import { URL, getAuthorizationHeader } from '../../constans/constants'
import { logout } from '../login/SesionService';
import axios from "axios";
import Cookies from 'universal-cookie';
import safeRedirectManager from "../seguridad/SafeRedirectComponent";

class SeleccionPca extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openPantallaCarga: false,
      idPsaSeleccionado: null
    };

    this.dialogRef = React.createRef();

  }


  handleFirmasPDF = (value) => {
    this.setState({ tipoFirma: value })
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  decodeBase64(base64data) {
    //let base64ToString = Buffer.from(base64data, "base64").toString()
    let base64ToString = atob(base64data);
    return base64ToString;
  }

  async obtenerAparienciaFirmaEmpleado() {
    const cookies = new Cookies();
    try {
      const res = await axios.get(
        `${URL}lote/getEmpleadoSignFormat/${this.props.idLote}/${cookies.get('username')}`,
        getAuthorizationHeader()
      );

      if (res.data.error === false) {
        return res.data.datos;
      }
      return null;

    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
      return error;
    }
  }

  async obtenerDatosUsuarioLogueado() {
    try {
      const response = await getUsuarioLogueado();
      return response;
    } catch (error) {
      console.error("Error al obtener los datos del usuario logueado:", error);
      throw error;
    }
  }

  handleSelectPsa = async (elemento) => {
    this.setState({ idPsaSeleccionado: elemento.id })
    localStorage.setItem("codigoClienteFirma", elemento.id)
    localStorage.setItem("proveedorFirma", elemento.codigoCliente)
    localStorage.setItem("redirectURLFirma", (this.props.url).substring(this.props.url.indexOf("#")))

    if (elemento.codigoCliente != TUID) {
      seleccionarPsa(elemento).then(res => {
        //window.location.replace(res);
        let isSafeRedirect = safeRedirectManager.safeRedirect(res);
        if (!isSafeRedirect)
          this.setState({ idPsaSeleccionado: null })
      })
    } else {
      var formatoFirmaEmpleado = await this.obtenerAparienciaFirmaEmpleado();
      var datosUsuario = await this.obtenerDatosUsuarioLogueado();
      var formatoEmpleado = null;
      if (formatoFirmaEmpleado != null) {
        formatoEmpleado = await loadSignature(formatoFirmaEmpleado, datosUsuario, null, false);
      }
      var json = {
        appearance: null
      }
      if (formatoEmpleado?.appearance) {
        json = await createGostCanvasAndGetAppareance(formatoEmpleado, json, null, null, null);
      }
      seleccionTuID(elemento, this.props.idLote, this.props.idRecibo, json).then(res => {
        //window.location.replace(res.datos);
        let isSafeRedirect = safeRedirectManager.safeRedirect(res.datos);
        if (!isSafeRedirect)
          this.setState({ idPsaSeleccionado: null })
      })
    }
  }

  componentDidMount() {
    // Manejar el estado inicial del modal
    if (this.props.isOpen) {
      this.abrirModal();
    }
  }

  componentDidUpdate(prevProps) {
    // Detectar cambios en isOpen para abrir/cerrar el modal
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        this.abrirModal();
      } else {
        this.cerrarModalConAnimacion();
      }
    }
  }

  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
    }
  }

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
    }
  }

  cerrarModalConAnimacion = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.style.scale = '0';
      setTimeout(() => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
          this.dialogRef.current.close();
        }
      }, 300);
    }
  }

  manejarCancelar = () => {
    this.cerrarModalConAnimacion();
    setTimeout(() => {
      this.props.cerrarModal();
    }, 300);
  }

  manejarConfirmar = () => {
    this.props.onConfirmar?.();
  }


  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
  }

  renderButton = (elemento) => {
    if (this.state.idPsaSeleccionado != null)
      return (
        <button className='btn-medium btn-primary' onClick={() => this.handleSelectPsa(elemento)} disabled>
          {this.state.idPsaSeleccionado == elemento.id ? 'Cargando...' : elemento.descripcion}

        </button>
      )
    else
      return (
        <button className='btn-medium btn-primary' onClick={() => this.handleSelectPsa(elemento)}>
          {elemento.descripcion}
        </button>
      )



  }

  render() {

    const modalHeadStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.5rem',
    };

    const iconButtonStyle = {
      background: 'none',
      border: 'none',
      padding: '0.25rem',
      cursor: 'pointer',
    };

    /* que cada “form‑group” llene todo el alto
   y coloque su card en una columna */
    const formGroupStyle = {
      flex: '1 1 0',        // mismo ancho/flex‑basis
      height: '100%',       // ocupa todo el alto de su fila
      display: 'flex',
      flexDirection: 'column',
    };

    /* la card también se estira y reparte
       espacio entre imagen y botón */
    const cardStyle = {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,              // llena el alto heredado
    };

    /* centra la imagen (h & v) dentro de card‑content */
    const cardContentStyle = {
      flex: 1,              // se expande para “empujar” el botón abajo
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };

    const { listaPsa, isOpen } = this.props;

    if (!isOpen) return null;

    if (listaPsa.length === 0)
      return (
        <Container>
          <Modal.Body>
            <div>
              <Row className="justify-content-center">
                <Col className="text-center text-md-right">
                  <img src={xCircle} style={{ margin: '40px' }}></img>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col className="text-center text-md-right">
                  <p><strong>No se encontraron proveedores de firma activos</strong></p>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Container>
      );

    else if (listaPsa.length === 1)
      this.handleSelectPsa(listaPsa[0])

    else
      return (
        <div className="component-modal">
          <dialog
            className="modal"
            id="modal-seleccion-psa"
            ref={this.dialogRef}
            onClose={this.manejarCancelar}
          >
            <div className="modal-content">
              <div className="modal-head" style={modalHeadStyle} >
                <h4 className="modal-title">Seleccione un proveedor de firma</h4>
                <button style={iconButtonStyle} onClick={this.cerrarModalConAnimacion} className="btn-medium">
                  <span className="material-symbols-outlined"> close </span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group__inline" 
                 style={{ display: 'flex', gap: '1rem', alignItems: 'stretch' }}
                >
                  {this.props.listaPsa.map((elemento) => (
                    <div className="form-group"  style={formGroupStyle} key={elemento.id}>
                      <div className="card" style={cardStyle}>
                        <div className="card-content">
                          {
                            elemento.logo != null
                              ? <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={"data:image/jpeg;base64," + this.decodeBase64(elemento.logo)} />
                              : <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={default_psa} />
                          }
                        </div>
                        {this.renderButton(elemento)}
                      </div>
                    </div>

                  ))}
                </div>

              </div>
            </div>

          </dialog>

        </div>
      );
  }
}

export default SeleccionPca;
